import React, { useEffect, useRef } from 'react';
import './ScrollTabs.css';
import PropTypes from 'prop-types';

let startScrollX;
let startX;
let moved = false;
let touch = false;
let isScrollIntoView = false;

const selectTabById = (id) => {
  const tabs = Array.from(document.querySelectorAll('.scroll-tabs-tab'));
  const tab = tabs[id];
  tabs.forEach((a) => {
    a.classList.remove('selected-tab');
    if (a === tab) a.classList.add('selected-tab');
  });
  return tab;
};

function findClosestIndex(arr, target) {
  let closestIndex = 0;
  let closestDiff = Math.abs(target - arr[0]);

  for (let i = 1; i < arr.length; i += 1) {
    const diff = Math.abs(target - arr[i]);
    if (diff < closestDiff) {
      closestIndex = i;
      closestDiff = diff;
    }
  }

  return closestIndex;
}

function handleScroll(contents) {
  if (!isScrollIntoView) {
    const y = contents.map((a) => a.getBoundingClientRect().y);
    const id = findClosestIndex(y, 20);
    const tab = selectTabById(id);
    tab.scrollIntoView();
  }
  isScrollIntoView = false;
}

const ScrollTabs = ({ tabs, header }) => {
  const headRef = useRef(null);
  const bodyRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const $popup = document.querySelector('.popup');
      const $popupHeader = document.querySelector('.popup-header');
      const { current: $head } = headRef;
      const { current: $body } = bodyRef;
      if (!$popup || !$popupHeader || !$head || !$body) {
        return;
      }
      const topHeadHeight = $popup.clientHeight - $head.clientHeight - $popupHeader.clientHeight;
      $body.style.height = `${topHeadHeight}px`;
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    moved = false;
    touch = false;
    isScrollIntoView = false;

    const { current: $head } = headRef;
    const { current: $body } = bodyRef;

    $body.onscroll = () => {
      const contents = Array.from(document.querySelectorAll('.scroll-tabs-tab-content'));
      handleScroll(contents);
    };

    $head.onmousewheel = (ev) => {
      const { current: $currentHead } = headRef;
      $currentHead.scrollLeft += 30 * (ev.deltaY > 1 ? 1 : -1);
    };

    const remover = (ev) => {
      if (touch && moved) ev.stopPropagation();
      touch = false;
      moved = false;
      document.removeEventListener('mouseup', remover);
    };

    $head.onmousedown = (ev) => {
      startScrollX = $head.scrollLeft;
      startX = ev.clientX;
      touch = true;
      moved = false;
      document.addEventListener('mouseup', remover);
    };

    $head.onmouseup = remover;

    $head.onmousemove = (ev) => {
      if (touch) {
        const { current: $currentHead } = headRef;
        moved = true;
        $currentHead.scrollLeft = startScrollX - (ev.clientX - startX);
      }
    };
  }, []);

  const tabClick = (ev) => {
    ev.target.scrollIntoView();

    const { current: $body } = bodyRef;
    const tabId = Array.from(document.querySelectorAll('.scroll-tabs-tab')).indexOf(ev.target);
    const contents = Array.from(document.querySelectorAll('.scroll-tabs-tab-content'));

    selectTabById(tabId);
    const content = contents[tabId];
    isScrollIntoView = true;
    content.scrollIntoView();
    $body.scrollTop -= 80;
  };

  return (
    <div className="scroll-tabs">
      <div className="scroll-tabs-head" ref={headRef}>
        {tabs.map((tab, i) => (
          <div key={i} className={`scroll-tabs-tab ${!i ? 'selected-tab' : ''}`} onMouseUp={tabClick}>
            {tab.alert > 0 && <span>{tab.alert}</span>}
            {tab.title}
          </div>
        ))}
      </div>
      <div className="scroll-tabs-body" ref={bodyRef}>
        { header || null }
        {tabs.map((tab, i) => (
          <div key={i} className="scroll-tabs-tab-content">{tab.body}</div>
        ))}
      </div>
    </div>
  );
};

ScrollTabs.propTypes = {
  tabs: PropTypes.array,
  header: PropTypes.any,
};

export default ScrollTabs;
